import { render } from "./Quiz.vue?vue&type=template&id=99f07ab0&scoped=true"
import script from "./Quiz.vue?vue&type=script&lang=js"
export * from "./Quiz.vue?vue&type=script&lang=js"

import "./Quiz.vue?vue&type=style&index=0&id=99f07ab0&scoped=true&lang=css"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99f07ab0"]])

export default __exports__